import React from 'react';
import cache from 'lscache';
import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { getSigninUrl } from '@/components/Auth/auth.utils';
import { AUTHENTICATION_STORAGE_KEY, TOKEN_KEY } from '@/components/Auth/auth.constants';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context, location }) => {
    const hasToken = !!cache.get(TOKEN_KEY);

    if (!hasToken) {
      sessionStorage.setItem(AUTHENTICATION_STORAGE_KEY, location.pathname);

      const url = await getSigninUrl();

      throw redirect({
        href: url,
      });
    }

    if (context.unauthorizedUser) {
      throw redirect({
        to: '/unauthorized',
      });
    }
  },
  component: () => <Outlet />,
});
